export enum VEHICLE_TRANSFER_STATUS {
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
}

export interface IVehicleInfo {
  licensePlate: string;
  companyId: string;
}

export interface IVehicleTransfer {
  _id: string;
  companyOriginId: string;
  companyDestinyId: string;
  status: string;
  vehicles: IVehicleInfo[];
  transferDate: string;
  arrivalDate: string;
  updatedAt: string;
  createdAt: string;
  totalItems: string;
}
